import { WSMutationConfig } from "@ws-react-query";
import {
  queriesNotifications,
  queriesPayers,
  queriesRequirements
} from "@query";
import { payersApi, personsApi } from "@api";
import { useSession } from "@hooks/useSession";
import { useWSMutation } from "../../../../query/helpers";
import { QUERY_PAYER_ROWS } from "../../../../query/search/payer/queries/useQueryPayerRows";
import { QUERY_PAYER_ROWS_SUMMARY } from "../../../../query/search/payer/queries/useQueryPayerRowsSummary";
import { selectorPersonDisplayName } from "../../../../shared/selectors/selectorPersonDisplayName";
import { buildTaxInformationConsent } from "../../../../shared/utils/buildTaxInformationConsent";
import { WSServiceError } from "../../../../utils/serviceHelper";

export const useMutationSubmit = (config?: WSMutationConfig<void>) => {
  const { personId } = useSession();

  return useWSMutation<any, WSServiceError, string[]>(
    async payerIds => {
      // v3 per-payer tax-information share (mirrors ModalShareTaxInformationWithPayers).
      // payerIds are v3 Payer ids carried on the W9Consent notification context.
      // INTERIM consent: signature derived from the payee's on-file legal name — no
      // dedicated e-signature capture yet; pending Legal sign-off (see buildTaxInformationConsent).
      const person = await personsApi.getPerson({ personId });
      const consent = buildTaxInformationConsent({
        signature: selectorPersonDisplayName(person)
      });

      return await Promise.all(
        payerIds.map(payerId =>
          payersApi.shareTaxInformation({
            payerId,
            payerShareTaxInformationRequest: { consent }
          })
        )
      );
    },
    {
      dependencies: [
        queriesNotifications.listNotifications.queryKeyBase,
        QUERY_PAYER_ROWS,
        QUERY_PAYER_ROWS_SUMMARY,
        queriesPayers.getPayer.queryKeyBase,
        queriesPayers.listPayers.queryKeyBase,
        queriesRequirements.listPayeeRequirements.queryKeyBase,
        queriesRequirements.getPayeeRequirement.queryKeyBase
      ],
      ...config
    }
  );
};
